import {BadgeInfoBlock} from "./BadgeInfoBlock";
import * as React from "react";
import {DashboardSolution} from "../../data/entities/DashboardSolution";
import {OverviewHTMLBlock} from "../widgets/OverviewHTMLBlock";

import './SolutionOverview.pcss';


interface Props {
  dashboardSolution?:DashboardSolution|null|undefined;
  solutionCurrentPoints?:number;
}

/**
 * An informational block displayed on the solution registration
 * page, and also on single bundle pages.
 *
 * @param props
 * @constructor
 */
export const SolutionOverview = (props:Props) => {
  if(props.dashboardSolution && (props.dashboardSolution.introduction || props.dashboardSolution.badgeUsed)) {
    return (
      <div className={"solution-overview"}>
        <OverviewHTMLBlock html={props.dashboardSolution.introduction} />
        <BadgeInfoBlock badgable={props.dashboardSolution} solutionCurrentPoints={props.solutionCurrentPoints} />
      </div>
    );
  } else {
    return null;
  }
}
